<template>
  <div :class="[first ? 'share-container-first' : '', 'share-container']" @click='toggleHover'>
    <div :class="[first ? 'first-share-icon' : 'share-icon']" >

    </div>
    <div class="share-tooltip" v-if="isHover">
        <a
            target="_blank"
            :href="makeFacebookLink(id, name, date)"
            class="fb-xfbml-parse-ignore share-tooltip__fb"
            tabindex="0"
            aria-label="Podziel się na Facebooku"
            >
            
        </a>
        <a
            target="_blank"
            :href="makeMailLink(id, name, date)"
            class="share-tooltip__mail"
            tabindex="0"
            aria-label="Podziel się przez EMail"
            >
            
        </a>
        <a
            target="_blank"
            :href="makeTwitterLink(id, name, date)"
            class="share-tooltip__twitter"
            tabindex="0"
            aria-label="Podziel się przez Twitter"
            >
            
        </a>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
    props: ['id', 'name', 'first', 'date'],
    mixins: [mixin],
}
</script>

<style scoped lang="scss">
    .share-container{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        &-first{
            margin-left: 1rem;
        }
    }

    .share-icon{
        background-image: url('./partials/share_button.png');
        background-position: center;
        background-repeat: no-repeat;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    .first-share-icon{
        background-image: url('./partials/share_button.png');
        background-position: center;
        background-repeat: no-repeat;
        width: 25px;
        height: 25px;
        cursor: pointer;
        background-size: contain;
    }
    .share-tooltip{
        display: flex;
        width: 5.6rem;
        height: 1.9rem;
        position: absolute;
        top: -2.5rem;
        left: -1.9rem;
        border-radius: 5px;

        &__fb{
            background-image: url('./partials/fb.png');
            background-position: center;
            background-repeat: no-repeat;
            background-color: #3569a7;
            width: 33%;
            height: 100%;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        &__mail{
            background-image: url('./partials/mail.png');
            background-position: center;
            background-repeat: no-repeat;
            background-color: #2c253f;
            width: 33%;
            height: 100%;
        }

        &__twitter{
            background-image: url('./partials/twitter.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: 60%;
            background-color: #21a2f2;
            width: 33%;
            height: 100%;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }

        &::before{
            position: absolute;
            content:'';
            display: block;
            background: #2c253f;
            width: 0.7rem;
            height: 0.7rem;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 50%) rotate(45deg);
        }
    }
</style>